import {
  Dialog,
  DialogContent,
  DialogTitle,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Box,
  TextField,
  DialogActions,
  IconButton
} from '@material-ui/core';
import { CloseOutlined } from '@material-ui/icons';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { usePartnerEvalutateStyles } from './styles';
import { useSnackbar } from '@components/Provider';
import { STORAGE_ACTION, getStorageItem } from '@utils/storage';
import { CustomizedTypography, CustomizedButton } from '@components/Customized';
import {
  CapaErrorCode,
  useEvaluateRfqPartnersMutation
} from '@generated/graphql';

interface Props {
  open: boolean;
  onClose: () => void;
  data: any;
  rfqId?: string | null;
  partnerId?: string;
}

type Key = { [key: string]: { checked: boolean; content: string } };

const PartnerEvalutationDialog = (props: Props) => {
  const isGhost = getStorageItem(STORAGE_ACTION.IS_GHOST_CLIENT);
  const classes = usePartnerEvalutateStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { register, handleSubmit, errors } = useForm();
  const [checkState, setCheckState] = useState<Key>({
    'a': {
      checked: false,
      content: '친절한 상담'
    },
    'b': {
      checked: false,
      content: '빠른 답장 및 응대'
    },
    'c': {
      checked: false,
      content: '상세한 견적서'
    },
    'd': {
      checked: false,
      content: '합리적인 가격'
    },
    'e': {
      checked: false,
      content: '다른 비교 대상이 없었음'
    },
    'f': {
      checked: false,
      content: '기타 (직접 입력)'
    }
  });

  const [evaluateRfqPartner] = useEvaluateRfqPartnersMutation();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckState({
      ...checkState,
      [event.target.name]: {
        checked: event.target.checked,
        content: checkState[event.target.name as string].content
      }
    });
  };

  const error = errors && errors['other_opinion'];

  const onSubmit = (submit: any) => {
    if (isGhost && isGhost === 'true') return;

    evaluateRfqPartner({
      variables: {
        input: {
          rfqId: props.rfqId as string,
          partners: [
            {
              quotationPartnerId: props.partnerId as string,
              etc: submit.other_opinion,
              kind: checkState['a'].checked,
              quick: checkState['b'].checked,
              detailed: checkState['c'].checked,
              helpful: checkState['d'].checked
            }
          ]
        }
      }
    })
      .then((result) => {
        if (result.data?.evaluateRfqPartners.result === CapaErrorCode.Success) {
          enqueueSnackbar('소중한 응답 감사합니다.', { variant: 'success' });
          localStorage.removeItem(STORAGE_ACTION.PARTNER_EVALUTATE);
          props.onClose();
        }
      })
      .catch((error) =>
        enqueueSnackbar('전송에 실패 했습니다.', { variant: 'error' })
      );
  };
  const { a, b, c, d, e, f } = checkState;

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      fullWidth={true}
      maxWidth={'sm'}
      className={classes.dialogWrapper}
    >
      <DialogTitle className={classes.dialogTitle}>
        <CustomizedTypography className={classes.title}>
          {props.data.company_name}의 서비스는 어떠셨나요?
          <IconButton style={{ padding: 6 }} onClick={props.onClose}>
            <CloseOutlined />
          </IconButton>
        </CustomizedTypography>
        <CustomizedTypography className={classes.subtitle}>
          타 파트너사 대비 더 만족스러웠던 부분을 선택해주세요. (복수 선택 가능)
          <span style={{ color: '#f44336' }}>*</span>
        </CustomizedTypography>
      </DialogTitle>
      <DialogContent>
        <FormGroup className={classes.dialogContent}>
          <FormControlLabel
            control={
              <Checkbox checked={a.checked} onChange={handleChange} name="a" />
            }
            name="a"
            label="친절한 상담"
          />
          <FormControlLabel
            control={
              <Checkbox checked={b.checked} onChange={handleChange} name="b" />
            }
            name="b"
            label="빠른 답장 및 응대"
          />
          <FormControlLabel
            control={
              <Checkbox checked={c.checked} onChange={handleChange} name="c" />
            }
            name="c"
            label="상세한 견적서"
          />
          <FormControlLabel
            control={
              <Checkbox checked={d.checked} onChange={handleChange} name="d" />
            }
            name="d"
            label="합리적인 가격"
          />
          <FormControlLabel
            control={
              <Checkbox checked={e.checked} onChange={handleChange} name="e" />
            }
            name="e"
            label="다른 비교 대상이 없었음"
          />
          <FormControlLabel
            control={
              <Checkbox checked={f.checked} onChange={handleChange} name="f" />
            }
            name="f"
            label="기타 (직접 입력)"
          />
        </FormGroup>

        <Box display="flex" flexDirection="column">
          <CustomizedTypography className={classes.opnion}>
            기타 의견 (선택)
          </CustomizedTypography>
          <TextField
            label=""
            fullWidth
            defaultValue=""
            variant="outlined"
            multiline
            className={classes.textfield}
            maxRows={7}
            minRows={7}
            error={error ? true : false}
            helperText={error ? '기타 선택시 기타 의견을 작성해주세요.' : ''}
            inputProps={{
              ref: register({
                required: checkState['f'].checked === true ? true : false
              }),
              name: 'other_opinion',
              placeholder:
                '위의 선택지 이외에 파트너의 만족스러웠던 부분, 아쉬웠던 부분을 적어주세요. 보내주신 소중한 의견은 더 나은 서비스로 보답하겠습니다. \n\n고객님의 의견은 파트너에게 공개되지 않으며, 서비스 개선을 위한 지표로 사용됩니다. '
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions className={classes.action}>
        <CustomizedButton
          type="submit"
          size="medium"
          color="primary"
          variant="contained"
          disableElevation
          onClick={handleSubmit(onSubmit)}
        >
          제출하기
        </CustomizedButton>
      </DialogActions>
    </Dialog>
  );
};

export default PartnerEvalutationDialog;
